import React, { useEffect } from "react";
import styles from "./Popup.module.css";

const Popup = ({ visible, onHide, children, y = 0 }) => {
  useEffect(() => {
    if (visible) {
      const timer = setTimeout(onHide, 1300);
      return () => clearTimeout(timer);
    }
  }, [visible, onHide]);

  if (!visible) return null;

  const popupStyle = {
    position: "absolute",
  };

  if (y !== 0) {
    popupStyle.bottom = `${y}px`;
  }

  return (
    <div className={styles.popupOverlay}>
      <div className={styles.popup} style={popupStyle}>

        {children}
      </div>
    </div>
  );
};

export default Popup;

